import { Observable } from "rxjs";
import { PlayerWS } from "@app/core/match/data/network/player.ws";
import { PlayerRepo } from "@app/core/match/domain/player.repo";
import { Injectable } from "@angular/core";
import { PlayerIdentificationInformationWS } from "@app/core/match/data/network/player-identification-information.ws";
import { PlayerIdentificationData } from "@app/core/match/domain/model/player-identification-data";

/**
 * A repository for the player.
 */
@Injectable()
export class PlayerDataRepo implements PlayerRepo {
  constructor(
    private playerWS: PlayerWS,
    private getPlayerIdentificationInformationWS: PlayerIdentificationInformationWS
  ) {}
  // Method to identify the player
  identifyPlayer(
    selected_code: number,
    match_code: string,
    victory: boolean | null,
    satisfaction: number | null,
    token: string
  ): Observable<void> {
    return this.playerWS.execute(
      selected_code,
      match_code,
      victory,
      satisfaction,
      token
    );
  }
  // Method to get the player's photo to select after in the identification process
  getPlayerIdentificationInformation(
    match_code: string,
    token: string
  ): Observable<PlayerIdentificationData> {
    return this.getPlayerIdentificationInformationWS.execute(match_code, token);
  }
}
